import { handleCoreServicesItemHeight } from "./core_services";

export function handleAboutToggle() {
    const aboutSection = document.querySelector('.aegis-about-about-section') as HTMLElement;
    if (!aboutSection) {
        return;
    }
    const aboutSectionBtn = document.querySelector('.aegis-about-btn') as HTMLElement;
    const coreSectionBtn = document.querySelector('.aegis-core-btn') as HTMLElement;
    const CoreSection = document.querySelector('.aegis-about-core-section') as HTMLElement;

    const urlParams = new URLSearchParams(window.location.search);
    const queryParams = Array.from(urlParams.entries());
    const queryArray = queryParams.map(([key, value]) => ({ key, value }));

    // Initial setup
    let currentSection = 'about';
    if (queryArray) {
        queryArray.forEach(query => {
            if (query.key === 'section' && query.value === 'core-services') {
                currentSection = 'core-services';
            }
        })
    }
    if (currentSection === 'about') {
        aboutSectionBtn.classList.add('active');
        aboutSection.classList.add('active');
    }
    if (currentSection === 'core-services') {
        coreSectionBtn.classList.add('active');
        CoreSection.classList.add('active');
    }

    // Event listener
    aboutSectionBtn.querySelector('.elementor-button-link').addEventListener('click', (e) => {
        e.preventDefault();
        aboutSectionBtn.classList.add('active');
        coreSectionBtn.classList.remove('active');
        aboutSection.classList.add('active');
        CoreSection.classList.remove('active');
    })
    coreSectionBtn.querySelector('.elementor-button-link').addEventListener('click', (e) => {
        e.preventDefault();
        coreSectionBtn.classList.add('active');
        aboutSectionBtn.classList.remove('active');
        CoreSection.classList.add('active');
        aboutSection.classList.remove('active');
        handleCoreServicesItemHeight();
    })
}

export function linkToCore() {
    const fragment = window.location.hash;
    if (fragment !== '#core') {
        return;
    }
    const aboutSection = document.querySelector('.aegis-about-about-section') as HTMLElement;
    const aboutSectionBtn = document.querySelector('.aegis-about-btn') as HTMLElement;
    const coreSectionBtn = document.querySelector('.aegis-core-btn') as HTMLElement;
    const CoreSection = document.querySelector('.aegis-about-core-section') as HTMLElement;

    coreSectionBtn.classList.add('active');
    aboutSectionBtn.classList.remove('active');
    CoreSection.classList.add('active');
    aboutSection.classList.remove('active');
    handleCoreServicesItemHeight();
}

export function handleFooterAboutMenu() {
    const footerAboutMenu = document.querySelector('#aegis-menu-about') as HTMLElement;
    const footerAboutMenuLinks = footerAboutMenu.querySelectorAll('.elementor-icon-list-item a') as NodeList;
    if (!footerAboutMenu) {
        return;
    }
    const link_1 = footerAboutMenuLinks[0] as HTMLAnchorElement;
    const link_2 = footerAboutMenuLinks[1] as HTMLElement;
    const link_3 = footerAboutMenuLinks[2] as HTMLElement;
    const link_4 = footerAboutMenuLinks[3] as HTMLElement;
    const aboutSection = document.querySelector('.aegis-about-about-section') as HTMLElement;
    const aboutSectionBtn = document.querySelector('.aegis-about-btn') as HTMLElement;
    const coreSectionBtn = document.querySelector('.aegis-core-btn') as HTMLElement;
    const CoreSection = document.querySelector('.aegis-about-core-section') as HTMLElement;

    link_1.addEventListener('click', e => {
        const urlWithoutHash = window.location.href.split('#')[0];
        const linkUrlWithoutHash = link_1.href.split('#')[0];
        if (urlWithoutHash !== linkUrlWithoutHash) {
            return;
        }
        e.preventDefault();
        aboutSectionBtn.classList.add('active');
        coreSectionBtn.classList.remove('active');
        aboutSection.classList.add('active');
        CoreSection.classList.remove('active');
    });
    link_2.addEventListener('click', e => {
        const urlWithoutHash = window.location.href.split('#')[0];
        const linkUrlWithoutHash = link_1.href.split('#')[0];
        if (urlWithoutHash !== linkUrlWithoutHash) {
            return;
        }
        e.preventDefault();
        aboutSectionBtn.classList.add('active');
        coreSectionBtn.classList.remove('active');
        aboutSection.classList.add('active');
        CoreSection.classList.remove('active');
    });
    link_3.addEventListener('click', e => {
        const urlWithoutHash = window.location.href.split('#')[0];
        const linkUrlWithoutHash = link_1.href.split('#')[0];
        if (urlWithoutHash !== linkUrlWithoutHash) {
            return;
        }
        e.preventDefault();
        aboutSectionBtn.classList.add('active');
        coreSectionBtn.classList.remove('active');
        aboutSection.classList.add('active');
        CoreSection.classList.remove('active');
    });
    link_4.addEventListener('click', e => {
        const urlWithoutHash = window.location.href.split('#')[0];
        const linkUrlWithoutHash = link_1.href.split('#')[0];
        if (urlWithoutHash !== linkUrlWithoutHash) {
            return;
        }
        e.preventDefault();
        coreSectionBtn.classList.add('active');
        aboutSectionBtn.classList.remove('active');
        CoreSection.classList.add('active');
        aboutSection.classList.remove('active');
    });
}